// src/pages/UpdateUser.js
import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Label,
  Input,
  Button,
  Card,
  CardBody,
  CardTitle,
  Form,
  Container,
  Alert,
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { fetchProvinsi } from "../../services/Master/masterProvinsi";
import { fetchUsersRegis, updateByEmail } from "../../services/userService";
import { useNavigate } from "react-router-dom";

const pendidikanOptions = [
  { value: "SMA/SMK", label: "SMA / SMK" },
  { value: "D1", label: "Diploma 1 (D1)" },
  { value: "D2", label: "Diploma 2 (D2)" },
  { value: "D3", label: "Diploma 3 (D3)" },
  { value: "S1", label: "Sarjana (S1)" },
  { value: "S2", label: "Magister (S2)" },
  { value: "S3", label: "Doktor (S3)" },
];

const UpdateUser = () => {
  const navigate = useNavigate();
  const [provinsi, setProvinsi] = useState([]);
  const [error, setError] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const [formData, setFormData] = useState({
    user_id: "",
    full_name: "",
    email: "",
    nomor_hp: "",
    tgl_lahir: "",
    jenis_kelamin: "",
    id_provinsi: null, // Ubah ke null atau 0
    pendidikan_terakhir: "",
    password: "",
    re_password: "",
  });

  useEffect(() => {
    const loadProvinsi = async () => {
      try {
        const res = await fetchProvinsi();
        if (res.success) {
          setProvinsi(res.data || []);
        }
      } catch (err) {
        console.error("Terjadi kesalahan saat memuat provinsi:", err);
      }
    };
    loadProvinsi();
  }, []);

  useEffect(() => {
    const loadUserData = async () => {
      setIsLoading(true);
      try {
        const res = await fetchUsersRegis();
        
        if (res.success && res.data && res.data.length > 0) {
          const userData = res.data[0];
          setFormData({
            user_id: userData.user_id || "",
            full_name: userData.full_name || "",
            email: userData.email || "",
            nomor_hp: userData.nomor_hp || "",
            tgl_lahir: userData.tgl_lahir ? userData.tgl_lahir.split('T')[0] : "",
            jenis_kelamin: userData.jenis_kelamin || "",
            id_provinsi: userData.id_provinsi || null, // Pastikan nilainya null jika kosong
            pendidikan_terakhir: userData.pendidikan_terakhir || "",
            password: "",
            re_password: "",
          });
          
        } else {
          setError("Data pengguna tidak ditemukan.");
        }
      } catch (err) {
        console.error("Error saat fetchUsersRegis:", err);
        setError("Gagal memuat data pengguna.");
      } finally {
        setIsLoading(false);
      }
    };
    loadUserData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // Langsung konversi nilai menjadi angka
    let finalValue = value;
    if (name === "id_provinsi") {
        finalValue = value === "" ? null : Number(value);
    }

    setFormData((prev) => ({ ...prev, [name]: finalValue }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccessMsg("");

    if (!formData.full_name || !formData.email || !formData.pendidikan_terakhir) {
      setError("Nama lengkap, email, dan pendidikan wajib diisi.");
      return;
    }

    if (formData.password) {
      if (formData.password.length < 8) {
        setError("Password minimal 8 karakter.");
        return;
      }
      if (formData.password !== formData.re_password) {
        setError("Password dan Ulangi Password tidak sama.");
        return;
      }
    }

    const payload = {
        data: {
            user_id: formData.user_id,
            full_name: formData.full_name,
            email: formData.email,
            nomor_hp: formData.nomor_hp,
            tgl_lahir: formData.tgl_lahir,
            jenis_kelamin: formData.jenis_kelamin,
            id_provinsi: formData.id_provinsi,
            pendidikan_terakhir: formData.pendidikan_terakhir,
            ...(formData.password && { password: formData.password })
        }
    };

    console.log("Payload yang dikirim:", payload);

    try {
        const res = await updateByEmail(formData.user_id, payload);
        if (res.success) {
            setSuccessMsg("Data pengguna berhasil diperbarui.");
        } else {
            setError(res.message || "Gagal memperbarui data pengguna.");
        }
    } catch (err) {
        console.error("Error updating user:", err);
        setError("Terjadi kesalahan saat memperbarui data.");
    }
  };

  if (isLoading) {
    return (
      <div className="page-content">
        <Container fluid>
          <p>Memuat data pengguna...</p>
        </Container>
      </div>
    );
  }

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="User" breadcrumbItem="Update User" />
        <Row>
          <Col lg={8}>
            <Card>
              <CardBody>
                <CardTitle className="h4 mb-4">Update User</CardTitle>
                {error && <Alert color="danger">{error}</Alert>}
                {successMsg && <Alert color="success">{successMsg}</Alert>}
                <Form onSubmit={handleSubmit}>
                  <Input type="hidden" name="user_id" value={formData.user_id} />
                  <Row className="mb-3 align-items-center">
                    <Label className="col-md-3 col-form-label">Nama Lengkap</Label>
                    <Col md={9}>
                      <Input
                        type="text"
                        name="full_name"
                        value={formData.full_name}
                        onChange={handleChange}
                        placeholder="Nama lengkap"
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3 align-items-center">
                    <Label className="col-md-3 col-form-label">Email</Label>
                    <Col md={9}>
                      <Input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="email@contoh.com"
                        disabled
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3 align-items-center">
                    <Label className="col-md-3 col-form-label">Nomor HP</Label>
                    <Col md={9}>
                      <Input
                        type="tel"
                        name="nomor_hp"
                        value={formData.nomor_hp}
                        onChange={handleChange}
                        placeholder="08xxxxxxxxxx"
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3 align-items-center">
                    <Label className="col-md-3 col-form-label">Tanggal Lahir</Label>
                    <Col md={9}>
                      <Input
                        type="date"
                        name="tgl_lahir"
                        value={formData.tgl_lahir}
                        onChange={handleChange}
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3 align-items-center">
                    <Label className="col-md-3 col-form-label">Jenis Kelamin</Label>
                    <Col md={9}>
                      <Input
                        type="select"
                        name="jenis_kelamin"
                        value={formData.jenis_kelamin}
                        onChange={handleChange}
                      >
                        <option value="">-- Pilih --</option>
                        <option value="L">Laki-laki</option>
                        <option value="P">Perempuan</option>
                      </Input>
                    </Col>
                  </Row>
                  <Row className="mb-3 align-items-center">
                    <Label className="col-md-3 col-form-label">Pendidikan Terakhir</Label>
                    <Col md={9}>
                      <Input
                        type="select"
                        name="pendidikan_terakhir"
                        value={formData.pendidikan_terakhir}
                        onChange={handleChange}
                      >
                        <option value="">-- Pilih Pendidikan --</option>
                        {pendidikanOptions.map((opt) => (
                          <option key={opt.value} value={opt.value}>
                            {opt.label}
                          </option>
                        ))}
                      </Input>
                    </Col>
                  </Row>
                  <Row className="mb-3 align-items-center">
                    <Label className="col-md-3 col-form-label">Provinsi</Label>
                    <Col md={9}>
                      <Input
                        type="select"
                        name="id_provinsi"
                        value={formData.id_provinsi || ""}
                        onChange={handleChange}
                      >
                        <option value="">-- Pilih Provinsi --</option>
                        {provinsi.map((p) => (
                          <option key={p.id} value={p.id}>
                            {p.name}
                          </option>
                        ))}
                      </Input>
                    </Col>
                  </Row>
                  <Row className="mb-3 align-items-center">
                    <Label className="col-md-3 col-form-label">Password</Label>
                    <Col md={9}>
                      <Input
                        type="password"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        placeholder="Kosongkan jika tidak ingin ganti"
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3 align-items-center">
                    <Label className="col-md-3 col-form-label">Ulangi Password</Label>
                    <Col md={9}>
                      <Input
                        type="password"
                        name="re_password"
                        value={formData.re_password}
                        onChange={handleChange}
                        placeholder="Ulangi password baru"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={{ size: 9, offset: 3 }} className="d-flex gap-2">
                      <Button color="primary" type="submit">
                        Update
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default UpdateUser;